import React, { useState } from "react";
import { FaChevronUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

interface IProps {
  categoriesData: any;
  setShowMobile: any
}

const Mobile: React.FC<IProps> = ({ categoriesData,setShowMobile }) => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [showSubCat, setShowSubCat] = useState<boolean | null>(false);

  const handleClickCategory = (cat: any) => {
    if (showSubCat === cat?.name) {
      setShowSubCat(null);
    } else {
      setShowSubCat(cat?.name);
    }
    setSelectedCategory(cat);
  };

  const handleClickCategort = (sub: any) => {
    navigate(`/product-categories/${sub?.id}?subCatName=${sub?.name}`)
    // navigate(`/product-categories/${sub?.id}?subCatName=${sub?.name}`);
    setShowMobile(false);
  }

  return (
    <div className="mt-8 space-y-1">
      {categoriesData?.map((item: any) => (
        <div
          key={item?.id}
          className="border rounded-lg shadow-sm transition-all duration-300 hover:shadow-md"
        >
          <div
            onClick={() => handleClickCategory(item)}
            className={`flex justify-between items-center px-3 py-2 cursor-pointer rounded-lg transition-colors ${item?.name === selectedCategory?.name ? 'bg-primary-color text-white' : 'bg-white'}`}
          >
            <p className="text-sm font-medium">{item?.name}</p>
            <div
              className={`text-gray-500 transition-transform duration-300 ${
                showSubCat && item?.name === selectedCategory?.name
                  ? "rotate-180"
                  : "rotate-0"
              }`}
            >
              <FaChevronUp className={`text-base transform ${item?.name === selectedCategory?.name ? 'text-white ' : 'text-black'}`} />
            </div>
          </div>


          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              showSubCat && item?.name === selectedCategory?.name
                ? "max-h-screen opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            {showSubCat && item?.name === selectedCategory?.name && (
              <div className="bg-white py-1 px-3 space-y-1 border-t border-gray-200" >
                {selectedCategory?.subCategories.map(
                  (sub: any, index: number) => (
                    <div
                      key={index}
                      className="pl-3 py-1 text-xs text-gray-600 hover:text-gray-800 hover:bg-gray-50 rounded-lg cursor-pointer transition-colors"
                      onClick={() => handleClickCategort(sub)}
                    >
                      {sub?.name}
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Mobile;
